import { FixedSeries } from "../DataSeries";


export class InputMap {
  constructor(map = {}, oldMap = {}) {
    if (map instanceof InputMap) {
      map = map.getMap();
    }

    if (oldMap) {
      this.inputMapping = this.remap(map, oldMap);
    } else {
      this.inputMapping = map;
    }
  }

  getMap() { return this.inputMapping; }


  /**
   * Merge the oldMap into the defaultMap with some simple
   * rules to streamline the CX
   * 
   * @param {Object} defaultMap 
   * @param {Object} oldMap 
   */
  inToOut = {
    'series': 'a', 'a': 'series'
  }

  remap(defaultMap, oldMap) {
    for (let key in oldMap) {
      if (key in this.inToOut && !(key in defaultMap)) {
        let newKey = this.inToOut[key];
        defaultMap[newKey] = oldMap[key];
      } else {
        defaultMap[key] = oldMap[key];
      }
    }
    return defaultMap;
  }

  changeInput(key, value) {
    this.inputMapping[key] = value;
  }


  /**
   * Replace all instances of oldValue in the inputMap
   *  with newValue
   * 
   * @param {String} oldValue Old value to remove
   * @param {String} newValue New value to insert in its place
   */
  swapInput(oldValue, newValue) {
    this.swapRootInput(oldValue, newValue);
    this.swapArrayInput(oldValue, newValue);
  }


  /**
   * Replace all v's with oldValue in the inputMap's
   * [k,v] pairs with the new value newValue
   * 
   * @param {String} oldValue Old value to remove
   * @param {String} newValue New value to insert in its place
   */
  swapRootInput(oldValue, newValue) {
    Object.entries(this.inputMapping).map(([k,v]) => {
      if (v === oldValue) {
        this.inputMapping[k] = newValue;
      }
    });
  }


  /**
   * Replace all instances of oldValue in an inputMap['args']
   * spot with newValue
   * 
   * @param {String} oldValue Old value to remove
   * @param {String} newValue New value to insert in its place
   */
  swapArrayInput(oldValue, newValue) {
    let argsVar = this.inputMapping['args'];

    if (argsVar) {
      argsVar.map((value, index) => {
        if (value === oldValue) {
          argsVar.splice(index, 1, newValue);
        }
      });
    }
  }
  

  /**
   * Merge an InputMap template with a ValueMap that converts some
   * subset of the InputMap values into a new set of values
   * 
   * Example:
   *    inputMap -> {a: 'apple', b: 4}
   *    valueMap -> {'apple': FancyMatrix}
   * 
   *    output -> {a: FancyMatrix, b: 4}
   * 
   * @param {Object} valueMap Mapping of input values to real values
   */
  fillInputs(valueMap) {
    let output = {};
    let unwrap = (value) => {
      let vmval = valueMap[value];
      if (vmval instanceof FixedSeries) {
        return valueMap[value][0].value;
      } else {
        return vmval ?? value;
      }
    }

    Object.entries(this.inputMapping).map(([k,v]) => {
      output[k] = unwrap(v);
    });


    let argsVar = this.inputMapping['args'];
    if (argsVar) {
      output['args'] = argsVar.map(i => unwrap(i));
    }
    
    return output;
  }
}